import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A6TransactionsEdit } from "./edit";
import { A6TransactionsNew } from "./new";
import { A6TransactionsTable } from "./table";

export default function A6Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A6TransactionsEdit />} />
      <Route index element={<A6TransactionsTable />} />
      <Route path="/new" element={<A6TransactionsNew />} />
    </Routes>
  );
}
